<template>
  <div class="premier12-wrap">
    <h1 class="premier12-hd schedule-premier12-hd">
      <span class="a11y-hidden">WBSC 프리미어 12 X wavve</span>
      <img src="../../assets/images/premier/logo-schedule.png" class="premier12-logo" alt="logo">
    </h1>
    <div class="tournament-info">
      <h2 class="free-hd">
        <span class="free-hd-inline">프리미어 12 독점중계</span>
        <strong>전국민 모두 <span class="free-txt">무료!</span></strong>
      </h2>
      <div class="schedule-tournament-wrap">
        <h3 class="round-hd">평가전</h3>
        <table class="schedule-tournament">
          <caption class="a11y-hidden">평가전 일정표</caption>
          <colgroup>
            <col>
            <col>
          </colgroup>
          <thead class="a11y-hidden">
          <tr>
            <th>일시</th>
            <th>경기 일정</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <span class="schedule-date">11/01(금)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">대한민국</span>
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">4 : 0</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/PR.png" alt="푸에르토리코 국기" class="schedule-country-img">
                  <span class="schedule-country-name">푸에르토리코</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="schedule-date">11/02(토)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">대한민국</span>
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">5 : 0</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/PR.png" alt="푸에르토리코 국기" class="schedule-country-img">
                  <span class="schedule-country-name">푸에르토리코</span>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <h3 class="round-hd">예선전</h3>
        <table class="schedule-tournament">
          <caption class="a11y-hidden">예선전 일정표</caption>
          <colgroup>
            <col width="26.4%">
            <col>
          </colgroup>
          <thead class="a11y-hidden">
          <tr>
            <th>일시</th>
            <th>경기 일정</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <span class="schedule-date">11/06(수)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">호주</span>
                  <img src="../../assets/images/premier/AU.png" alt="호주 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">0 : 5</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                  <span class="schedule-country-name">대한민국</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="schedule-date">11/07(목)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">대한민국</span>
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">3 : 1</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/CA.png" alt="캐나다 국기" class="schedule-country-img">
                  <span class="schedule-country-name">캐나다</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="schedule-date">11/08(금)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">쿠바</span>
                  <img src="../../assets/images/premier/CU.png" alt="쿠바 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">0 : 7</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                  <span class="schedule-country-name">대한민국</span>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <h3 class="round-hd">슈퍼라운드</h3>
        <table class="schedule-tournament">
          <caption class="a11y-hidden">슈퍼라운드 일정표</caption>
          <colgroup>
            <col width="26.4%">
            <col>
          </colgroup>
          <thead class="a11y-hidden">
          <tr>
            <th>일시</th>
            <th>경기 일정</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <span class="schedule-date">11/11(월)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">미국</span>
                  <img src="../../assets/images/premier/US.png" alt="미국 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">1 : 5</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                  <span class="schedule-country-name">대한민국</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="schedule-date">11/12(화)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">대만</span>
                  <img src="../../assets/images/premier/TP.png" alt="대만 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">7 : 0</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                  <span class="schedule-country-name">대한민국</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="schedule-date">11/15(금)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">멕시코</span>
                  <img src="../../assets/images/premier/MX.png" alt="멕시코 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">3 : 7</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                  <span class="schedule-country-name">대한민국</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="schedule-date">11/16(토)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">대한민국</span>
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">8 : 10</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/JP.png" alt="일본 국기" class="schedule-country-img">
                  <span class="schedule-country-name">일본</span>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <h3 class="round-hd">결승전</h3>
        <table class="schedule-tournament">
          <caption class="a11y-hidden">결승전 일정표</caption>
          <colgroup>
            <col width="26.4%">
            <col>
          </colgroup>
          <thead class="a11y-hidden">
          <tr>
            <th>일시</th>
            <th>경기 일정</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <span class="schedule-date">11/17(일)</span>
            </td>
            <td>
              <div class="schedule-country-info">
                <div class="schedule-country-box schedule-country-box-visitor">
                  <span class="schedule-country-name">대한민국</span>
                  <img src="../../assets/images/premier/KR.png" alt="대한민국 국기" class="schedule-country-img">
                </div>
                <span class="schedule-versus schedule-versus-result">3 : 5</span>
                <div class="schedule-country-box schedule-country-box-home">
                  <img src="../../assets/images/premier/JP.png" alt="일본 국기" class="schedule-country-img">
                  <span class="schedule-country-name">일본</span>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="link-box schedule-link-box">
      <a href="#" class="link-common link-onair" @click.prevent="goToLive()">
        wavve 앱 실행하기
      </a>
    </div>
    <div class="ranking-now schedule-ranking-now">
      <p class="ranking-now-txt">전체 일정, 결과가 궁금하다면?</p>
      <a @click.prevent="rankingUrl()" class="link-direct">바로가기</a>
    </div>
    <p class="premier12-exclamation">
      <span class="premier12-exclamation-dot">
        <span class="premier12-exclamation-txt">WBSC 프리미어12는 wavve에서 온라인 독점 무료 생중계합니다.</span>
      </span>
      <span class="premier12-exclamation-dot">
        <span class="premier12-exclamation-txt">원활한 시청을 위해 최신 버전 설치가 필요합니다.</span>
      </span>
    </p>
  </div>
</template>

<script>
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { enableBodyScroll } from '@/common/util/ui.utils'
export default {
  data () {
    return {
      device: '',
      title: '',
      channelId: '',
      startTime: ''
    }
  },
  methods: {
    moveHome () {
      sessionStorage.setItem('CONFIRM_PREMIER12', 'y')
      if (this.device === 'ios' && get(window, ['webkit', 'messageHandlers'], '') !== '') {
        window.webkit.messageHandlers.WebClose.postMessage('WebClose')
      } else if (this.device === 'android' && get(window, 'Android', '') !== '') {
        location.href = 'captvpooq://webclose'
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    goToLive () {
      if (this.device === 'ios') {
        utils.common.checkInstallApps(`player/emergency/live?channelid=${this.channelId}&title=${this.title}&starttime=${this.startTime}`)
      } else if (this.device === 'android') {
        location.href = `captvpooq://player/emergency/live?channelid=${this.channelId}&title=${this.title}&starttime=${this.startTime}`
      } else {
        utils.common.checkInstallApps('player')
      }
    },
    rankingUrl () {
      const url = 'https://premier12.wbsc.org/ko/2019/schedule-and-results '
      if ((this.device === 'ios' && get(window, ['webkit', 'messageHandlers'], '') !== '') ||
          (this.device === 'android' && get(window, 'Android', '') !== '')) {
        location.href = `captvpooq://webview?url=${encodeURIComponent(url)}&external=y`
      } else {
        window.open(url, '_blank')
      }
    }
  },
  created () {
    enableBodyScroll()
    this.device = get(this.$route, ['query', 'device'], '')
    this.title = get(this.$route, ['query', 'title'], 'test')
    this.channelId = get(this.$route, ['query', 'channelid'], 'S02')
    this.startTime = get(this.$route, ['query', 'starttime'], '12:00')
  }
}
</script>
<style lang="css" src="@/assets/new-css/premier12.css"></style>
